export default {
    "en": {
        "photoRestoration": {
            "title": "Free AI Photo Restoration - Repair Old Photos | WeryAI",
            "description": "Restore old family photos with AI -- colorize black & white images, repair scratches, and sharpen blurry details. Free credits on signup, no card needed.",
            "keywords": "old photo restoration, colorize photos, fix scratched photos, ai photo repair, restore old pictures, black and white to color, image restoration ai",
            "og_title": "Free AI Photo Restoration - Repair Old Photos | WeryAI",
            "og_description": "Restore old family photos with AI -- colorize black & white images, repair scratches, and sharpen blurry details. Free credits on signup, no card needed.",
            "twitter_title": "Free AI Photo Restoration - Repair Old Photos | WeryAI",
            "twitter_description": "Restore old family photos with AI -- colorize black & white images, repair scratches, and sharpen blurry details. Free credits on signup, no card needed.",
            "page": {
                "title1": "Free AI Old Photo Restoration & Colorizer",
                "title2": "Bring your history back to life. Whether it's a faded black-and-white wedding photo or a scratched childhood portrait, our AI analyzes and restores damaged areas, sharpens faces, and intelligently adds realistic colors in seconds.",
                "faq": [
                    {
                        "question": "How do I colorize a black and white photo?",
                        "answer": "Simply upload your B&W image to WeryAI. The tool automatically detects it's grayscale and applies the \"Colorize\" feature to add realistic colors instantly."
                    },
                    {
                        "question": "Can it fix torn or scratched photos?",
                        "answer": "Yes. Our AI is trained to recognize scratches, tears, and creases. It fills these damaged areas with pixels that match the surrounding texture."
                    },
                    {
                        "question": "Will the restored photo look fake?",
                        "answer": "Our goal is realism. While face enhancement adds details, we strive to keep the person's identity recognizable. For colorization, the AI chooses natural tones suitable for the era."
                    },
                    {
                        "question": "What if the photo is very small?",
                        "answer": "No problem. The restoration process also includes Upscaling, which increases the resolution of small wallet-sized photos for digital viewing or printing. Want to upscale the restored photo? Try our <a href=\"/image-upscaler\">Image Upscaler</a>."
                    },
                    {
                        "question": "Is my privacy protected?",
                        "answer": "Yes. We understand old photos are personal. Your images are processed securely and are not stored permanently on our servers."
                    },
                    {
                        "question": "Can I use WeryAI Photo Restoration for free?",
                        "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Photo Restoration tool without an upfront payment."
                    }
                ]
            },
            "faq": [
                {
                    "question": "How do I colorize a black and white photo?",
                    "answer": "Simply upload your B&W image to WeryAI. The tool automatically detects it's grayscale and applies the \"Colorize\" feature to add realistic colors instantly."
                },
                {
                    "question": "Can it fix torn or scratched photos?",
                    "answer": "Yes. Our AI is trained to recognize scratches, tears, and creases. It fills these damaged areas with pixels that match the surrounding texture."
                },
                {
                    "question": "Will the restored photo look fake?",
                    "answer": "Our goal is realism. While face enhancement adds details, we strive to keep the person's identity recognizable. For colorization, the AI chooses natural tones suitable for the era."
                },
                {
                    "question": "Can I use WeryAI Photo Restoration for free?",
                    "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Photo Restoration tool without an upfront payment."
                }
            ],
            "feature_title1": "Scratch & Tear Removal",
            "feature_desc1": "Erase Time's Marks: Automatically detect and fill creases, scratches, rips, and dust spots. Our AI reconstructs missing facial details to make the photo look new again.",
            "feature_title2": "Intelligent Colorization",
            "feature_desc2": "B&W to Color: Not just a sepia filter. Our Deep Learning model understands context (sky, skin, fabric) to add historically accurate and vibrant colors to black-and-white photos.",
            "feature_title3": "Face Enhancement",
            "feature_desc3": "Unblur Faces: Old photos often suffer from motion blur or low focus. WeryAI sharpens facial features (eyes, nose, mouth) to reveal the true likeness of your ancestors.",
            "howto": {
                "name": "How to Colorize and Restore Old Photos",
                "step1": {
                    "name": "Upload Photo",
                    "text": "Upload an old, damaged, or black and white photo to WeryAI."
                },
                "step2": {
                    "name": "AI Processing",
                    "text": "The AI will automatically detect damage and color information. It will repair scratches and apply color simultaneously."
                },
                "step3": {
                    "name": "Download",
                    "text": "Preview the restored image and download the high-quality version."
                }
            }
        }
    },
    "zh": {
        "photoRestoration": {
            "title": "免费 AI 老照片修复 - 修复旧照片 | WeryAI",
            "description": "使用 WeryAI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。",
            "keywords": "老照片修复, 照片上色, 修复划痕照片, AI 照片修复, 恢复旧照片, 黑白转彩色, AI 图像修复",
            "og_title": "免费 AI 老照片修复 - 修复旧照片 | WeryAI",
            "og_description": "使用 WeryAI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。",
            "twitter_title": "免费 AI 老照片修复 - 修复旧照片 | WeryAI",
            "twitter_description": "使用 WeryAI 的免费 AI 照片修复功能，让旧家庭回忆重获新生。自动为黑白照片上色，去除划痕、撕裂和模糊，瞬间恢复人脸。",
            "page": {
                "title1": "免费 AI 老照片修复和上色工具",
                "title2": "让您的历史重获新生。无论是褪色的黑白婚纱照还是划痕累累的童年肖像，我们的 AI 都能在几秒钟内分析并修复受损区域，锐化人脸，智能添加逼真的颜色。",
                "faq": [
                    {
                        "question": "如何为黑白照片上色？",
                        "answer": "只需将您的黑白图像上传到 WeryAI。工具会自动检测它是灰度图像，并应用\"上色\"功能，立即添加逼真的颜色。"
                    },
                    {
                        "question": "可以修复撕裂或划痕的照片吗？",
                        "answer": "可以。我们的 AI 经过训练，能够识别划痕、撕裂和折痕。它会用与周围纹理匹配的像素填充这些受损区域。"
                    },
                    {
                        "question": "修复后的照片会看起来很假吗？",
                        "answer": "我们的目标是真实感。虽然人脸增强会添加细节，但我们努力保持人物身份的可识别性。对于上色，AI 会选择适合该时代的自然色调。"
                    },
                    {
                        "question": "如果照片非常小怎么办？",
                        "answer": "没问题。修复过程还包括放大功能，可以提高小尺寸钱包照片的分辨率，用于数字查看或打印。"
                    },
                    {
                        "question": "我的隐私是否受到保护？",
                        "answer": "是的。我们理解旧照片是私人的。您的图像会被安全处理，不会永久存储在我们的服务器上。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "如何为黑白照片上色？",
                    "answer": "只需将您的黑白图像上传到 WeryAI。工具会自动检测它是灰度图像，并应用\"上色\"功能，立即添加逼真的颜色。"
                },
                {
                    "question": "可以修复撕裂或划痕的照片吗？",
                    "answer": "可以。我们的 AI 经过训练，能够识别划痕、撕裂和折痕。它会用与周围纹理匹配的像素填充这些受损区域。"
                },
                {
                    "question": "修复后的照片会看起来很假吗？",
                    "answer": "我们的目标是真实感。虽然人脸增强会添加细节，但我们努力保持人物身份的可识别性。对于上色，AI 会选择适合该时代的自然色调。"
                }
            ],
            "feature_title1": "划痕和撕裂去除",
            "feature_desc1": "擦除时间的痕迹：自动检测并填充折痕、划痕、撕裂和灰尘斑点。我们的 AI 重建缺失的面部细节，让照片看起来焕然一新。",
            "feature_title2": "智能上色",
            "feature_desc2": "黑白转彩色：不仅仅是棕褐色滤镜。我们的深度学习模型理解上下文（天空、皮肤、织物），为黑白照片添加历史上准确且生动的颜色。",
            "feature_title3": "人脸增强",
            "feature_desc3": "去模糊人脸：旧照片经常遭受运动模糊或低焦点问题。WeryAI 锐化面部特征（眼睛、鼻子、嘴巴），揭示您祖先的真实面貌。",
            "howto": {
                "name": "如何为老照片上色和修复",
                "step1": {
                    "name": "上传照片",
                    "text": "将旧的、损坏的或黑白照片上传到 WeryAI。"
                },
                "step2": {
                    "name": "AI 处理",
                    "text": "AI 将自动检测损坏和颜色信息。它会同时修复划痕和上色。"
                },
                "step3": {
                    "name": "下载",
                    "text": "预览修复后的图片并下载高质量版本。"
                }
            }
        }
    },
    "ja": {
        "photoRestoration": {
            "title": "無料 AI 写真修復 - 古い写真を修復 | WeryAI",
            "description": "WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。",
            "keywords": "古い写真 修復, 写真 カラー化, 傷 写真 修復, AI 写真修復, 古い写真 復元, 白黒 カラー, 画像修復 AI",
            "og_title": "無料 AI 写真修復 - 古い写真を修復 | WeryAI",
            "og_description": "WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。",
            "twitter_title": "無料 AI 写真修復 - 古い写真を修復 | WeryAI",
            "twitter_description": "WeryAIの無料AI写真修復で、古い家族の思い出を蘇らせましょう。白黒写真を自動でカラー化し、傷・破れ・ぼやけを除去して顔を瞬時に復元します。",
            "page": {
                "title1": "無料AI古い写真修復＆カラー化",
                "title2": "あなたの歴史をもう一度、鮮やかに。色あせた白黒の結婚写真でも、傷だらけの子どもの頃の肖像でも、AIが損傷箇所を解析して修復し、顔をシャープにし、数秒で自然な色を賢く追加します。",
                "faq": [
                    {
                        "question": "白黒写真をカラー化するには？",
                        "answer": "白黒画像をWeryAIにアップロードするだけ。ツールがグレースケールを自動検出し、「カラー化」機能でリアルな色をすぐに付けます。"
                    },
                    {
                        "question": "破れや傷のある写真も修復できますか？",
                        "answer": "はい。AIは傷、破れ、折り目を認識できるよう学習しています。周囲の質感に合うピクセルで損傷部分を自然に埋めます。"
                    },
                    {
                        "question": "修復後の写真が不自然に見えませんか？",
                        "answer": "私たちの目標はリアルさです。顔の補正でディテールは増えますが、本人らしさが分かるように調整します。カラー化も年代に合う自然な色味を選びます。"
                    },
                    {
                        "question": "写真がとても小さい場合は？",
                        "answer": "問題ありません。修復プロセスにはアップスケールも含まれ、小さな写真の解像度を上げて閲覧や印刷に使えるようにします。"
                    },
                    {
                        "question": "プライバシーは守られますか？",
                        "answer": "はい。古い写真はとても個人的なものだと理解しています。画像は安全に処理され、サーバーに永久保存しません。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "白黒写真をカラー化するには？",
                    "answer": "白黒画像をWeryAIにアップロードするだけ。ツールが自動で検出し、「カラー化」機能でリアルな色を追加します。"
                },
                {
                    "question": "破れや傷のある写真も修復できますか？",
                    "answer": "はい。AIが傷や破れを認識し、周囲の質感に合うピクセルで自然に埋めます。"
                },
                {
                    "question": "修復後の写真が不自然に見えませんか？",
                    "answer": "リアルさを重視しています。本人らしさを保ちつつ、自然な補正とカラー化を行います。"
                }
            ],
            "feature_title1": "傷・破れの除去",
            "feature_desc1": "時間の痕跡を消す：折り目、傷、破れ、ホコリ汚れを自動検出して補完。失われた顔のディテールも再構築し、写真を新品のように見せます。",
            "feature_title2": "スマートカラー化",
            "feature_desc2": "白黒→カラー：セピアフィルターではありません。深層学習モデルが文脈（空、肌、布地）を理解し、歴史的に自然で鮮やかな色を追加します。",
            "feature_title3": "顔の鮮明化",
            "feature_desc3": "ぼやけた顔をくっきり：古い写真は手ブレやピント不足が起きがち。WeryAIが目・鼻・口などの特徴をシャープにし、家族の面影をはっきり蘇らせます。",
            "howto": {
                "name": "古い写真をカラー化して復元する方法",
                "step1": {
                    "name": "写真をアップロード",
                    "text": "WeryAIに古い、損傷した、または白黒の写真をアップロードします。"
                },
                "step2": {
                    "name": "AI処理",
                    "text": "AIが損傷と色情報を自動的に検出します。傷を修復し、同時に色を適用します。"
                },
                "step3": {
                    "name": "ダウンロード",
                    "text": "復元された画像をプレビューし、高品質バージョンをダウンロードします。"
                }
            }
        }
    },
    "ko": {
        "photoRestoration": {
            "title": "무료 AI 사진 복원 - 오래된 사진 수리 | WeryAI",
            "description": "WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.",
            "keywords": "AI 사진 복원, 흑백 사진 컬러화, 오래된 사진 복구, 스크래치 제거, 찢어진 사진 복원, AI 사진 수리, 이미지 복원 AI",
            "og_title": "무료 AI 사진 복원 - 오래된 사진 수리 | WeryAI",
            "og_description": "WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.",
            "twitter_title": "무료 AI 사진 복원 - 오래된 사진 수리 | WeryAI",
            "twitter_description": "WeryAI의 무료 AI 사진 복원으로 오래된 가족의 추억을 되살리세요. 흑백 사진을 자동으로 컬러화하고, 스크래치·찢김·흐림을 제거해 얼굴을 즉시 복원합니다.",
            "page": {
                "title1": "무료 AI 오래된 사진 복원 & 컬러라이저",
                "title2": "당신의 역사를 다시 생생하게. 바랜 흑백 결혼사진이든, 스크래치가 가득한 어린 시절 초상이든, AI가 손상 부위를 분석해 복원하고 얼굴을 선명하게 만들며 몇 초 만에 자연스러운 색을 똑똑하게 더합니다.",
                "faq": [
                    {
                        "question": "흑백 사진을 컬러로 바꾸려면 어떻게 하나요?",
                        "answer": "흑백 이미지를 WeryAI에 업로드만 하세요. 도구가 그레이스케일을 자동 감지하고 “컬러화” 기능을 적용해 현실적인 색을 즉시 입힙니다."
                    },
                    {
                        "question": "찢어지거나 스크래치 난 사진도 고칠 수 있나요?",
                        "answer": "네. AI는 스크래치, 찢김, 접힘을 인식하도록 학습되어 있으며, 주변 텍스처에 맞는 픽셀로 손상 부위를 자연스럽게 채웁니다."
                    },
                    {
                        "question": "복원 결과가 가짜처럼 보이지 않나요?",
                        "answer": "목표는 ‘현실감’입니다. 얼굴 향상은 디테일을 더하지만 인물이 알아볼 수 있게 유지합니다. 컬러화도 시대감에 맞는 자연스러운 톤을 선택합니다."
                    },
                    {
                        "question": "사진이 매우 작아도 되나요?",
                        "answer": "문제없습니다. 복원 과정에는 업스케일링도 포함되어 작은 지갑 사진도 해상도를 높여 디지털 감상이나 인쇄에 사용할 수 있습니다."
                    },
                    {
                        "question": "개인정보는 보호되나요?",
                        "answer": "네. 오래된 사진은 개인적이라는 점을 이해합니다. 이미지는 안전하게 처리되며 서버에 영구 저장되지 않습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "흑백 사진을 컬러로 바꾸려면 어떻게 하나요?",
                    "answer": "흑백 이미지를 업로드하면 자동 감지 후 “컬러화” 기능으로 현실적인 색을 즉시 입힙니다."
                },
                {
                    "question": "찢어지거나 스크래치 난 사진도 고칠 수 있나요?",
                    "answer": "네. AI가 손상 부위를 인식해 주변 텍스처에 맞게 자연스럽게 복원합니다."
                },
                {
                    "question": "복원 결과가 가짜처럼 보이지 않나요?",
                    "answer": "현실감을 우선합니다. 인물의 정체성을 유지하면서 자연스럽게 보정합니다."
                }
            ],
            "feature_title1": "스크래치 & 찢김 제거",
            "feature_desc1": "시간의 흔적 지우기: 접힘, 스크래치, 찢김, 먼지 얼룩을 자동 감지해 채웁니다. AI가 사라진 얼굴 디테일까지 재구성해 새 사진처럼 만듭니다.",
            "feature_title2": "지능형 컬러라이징",
            "feature_desc2": "흑백→컬러: 단순 세피아 필터가 아닙니다. 딥러닝이 맥락(하늘, 피부, 천)을 이해해 시대에 자연스럽고 선명한 색을 더합니다.",
            "feature_title3": "얼굴 선명화",
            "feature_desc3": "흐린 얼굴 복원: 오래된 사진은 흔들림이나 초점 부족이 많습니다. WeryAI가 눈·코·입 등 특징을 선명하게 만들어 가족의 모습을 또렷하게 되살립니다.",
            "howto": {
                "name": "오래된 사진 복원 및 채색하는 방법",
                "step1": {
                    "name": "사진 업로드",
                    "text": "오래되거나 손상된 사진, 또는 흑백 사진을 WeryAI에 업로드하세요."
                },
                "step2": {
                    "name": "AI 처리",
                    "text": "AI가 손상된 부분과 색상 정보를 자동으로 감지합니다. 스크래치를 복구하고 동시에 색상을 입힙니다."
                },
                "step3": {
                    "name": "다운로드",
                    "text": "복원된 이미지를 미리 보고 고품질 버전으로 다운로드하세요."
                }
            }
        }
    },
    "es": {
        "photoRestoration": {
            "title": "Restaurar Fotos Antiguas con IA Gratis | WeryAI",
            "description": "Revive recuerdos familiares con la Restauración de Fotos IA Gratis de WeryAI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.",
            "keywords": "restauración de fotos antiguas, colorizar fotos, reparar fotos rayadas, reparación de fotos IA, restaurar fotos viejas, blanco y negro a color, restauración de imágenes IA",
            "og_title": "Restaurar Fotos Antiguas con IA Gratis | WeryAI",
            "og_description": "Revive recuerdos familiares con la Restauración de Fotos IA Gratis de WeryAI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.",
            "twitter_title": "Restaurar Fotos Antiguas con IA Gratis | WeryAI",
            "twitter_description": "Revive recuerdos familiares con la Restauración de Fotos IA Gratis de WeryAI. Coloriza automáticamente fotos en blanco y negro, elimina rayones, roturas y desenfoque para restaurar rostros al instante.",
            "page": {
                "title1": "Restauración y Colorizador de Fotos Antiguas con IA Gratis",
                "title2": "Devuelve tu historia a la vida. Ya sea una foto de boda en blanco y negro desvanecida o un retrato infantil rayado, nuestra IA analiza y restaura áreas dañadas, afina rostros y añade colores realistas en segundos.",
                "faq": [
                    {
                        "question": "¿Cómo colorizo una foto en blanco y negro?",
                        "answer": "Solo sube tu imagen B&N a WeryAI. La herramienta detecta automáticamente que es en escala de grises y aplica la función “Colorizar” para añadir colores realistas al instante."
                    },
                    {
                        "question": "¿Puede arreglar fotos rasgadas o rayadas?",
                        "answer": "Sí. Nuestra IA está entrenada para reconocer rayones, roturas y pliegues. Rellena esas zonas dañadas con píxeles que coinciden con la textura alrededor."
                    },
                    {
                        "question": "¿La foto restaurada se verá falsa?",
                        "answer": "Nuestro objetivo es el realismo. La mejora facial añade detalles, pero buscamos mantener la identidad reconocible. En la colorización, la IA elige tonos naturales adecuados para la época."
                    },
                    {
                        "question": "¿Qué pasa si la foto es muy pequeña?",
                        "answer": "No hay problema. El proceso también incluye Upscaling, que aumenta la resolución de fotos pequeñas tipo billetera para verlas o imprimirlas."
                    },
                    {
                        "question": "¿Mi privacidad está protegida?",
                        "answer": "Sí. Sabemos que las fotos antiguas son personales. Tus imágenes se procesan de forma segura y no se almacenan permanentemente en nuestros servidores."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Cómo colorizo una foto en blanco y negro?",
                    "answer": "Sube tu imagen B&N a WeryAI y la función “Colorizar” añadirá colores realistas al instante."
                },
                {
                    "question": "¿Puede arreglar fotos rasgadas o rayadas?",
                    "answer": "Sí. La IA detecta daños como rayones y roturas y los rellena de forma natural según la textura alrededor."
                },
                {
                    "question": "¿La foto restaurada se verá falsa?",
                    "answer": "Buscamos realismo: mantener la identidad y aplicar colores naturales apropiados."
                }
            ],
            "feature_title1": "Eliminación de Rayones y Roturas",
            "feature_desc1": "Borra las marcas del tiempo: Detecta y rellena pliegues, rayones, roturas y manchas de polvo automáticamente. La IA reconstruye detalles faciales perdidos para que la foto se vea como nueva.",
            "feature_title2": "Colorización Inteligente",
            "feature_desc2": "De B&N a Color: No es solo un filtro sepia. Nuestro modelo entiende el contexto (cielo, piel, tela) para añadir colores vivos y realistas a fotos antiguas.",
            "feature_title3": "Mejora de Rostro",
            "feature_desc3": "Desenfoca Caras: Las fotos antiguas suelen tener movimiento o poco enfoque. WeryAI afina rasgos (ojos, nariz, boca) para revelar el parecido real.",
            "howto": {
                "name": "Cómo colorear y restaurar fotos antiguas",
                "step1": {
                    "name": "Subir foto",
                    "text": "Sube una foto antigua, dañada o en blanco y negro a WeryAI."
                },
                "step2": {
                    "name": "Procesamiento de IA",
                    "text": "La IA detectará automáticamente los daños y la información de color. Reparará los rasguños y aplicará color simultáneamente."
                },
                "step3": {
                    "name": "Descargar",
                    "text": "Obtén una vista previa de la imagen restaurada y descarga la versión de alta calidad."
                }
            }
        }
    },
    "fr": {
        "photoRestoration": {
            "title": "Restauration Photo IA - Réparer Photos | WeryAI",
            "description": "Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de WeryAI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.",
            "keywords": "restauration photo ancienne, coloriser photo, réparer photo rayée, réparation photo IA, restaurer vieilles photos, noir et blanc en couleur, restauration d'image IA",
            "og_title": "Restauration Photo IA - Réparer Photos | WeryAI",
            "og_description": "Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de WeryAI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.",
            "twitter_title": "Restauration Photo IA - Réparer Photos | WeryAI",
            "twitter_description": "Ravivez vos souvenirs familiaux avec la Restauration Photo IA gratuite de WeryAI. Colorisez automatiquement les photos noir et blanc, supprimez rayures, déchirures et flou pour restaurer les visages instantanément.",
            "page": {
                "title1": "Restauration & Colorisation de Vieilles Photos par IA (Gratuit)",
                "title2": "Redonnez vie à votre histoire. Qu'il s'agisse d'une photo de mariage noir et blanc délavée ou d'un portrait d'enfance rayé, notre IA analyse et restaure les zones abîmées, affine les visages et ajoute des couleurs réalistes en quelques secondes.",
                "faq": [
                    {
                        "question": "Comment coloriser une photo noir et blanc ?",
                        "answer": "Téléchargez simplement votre image N&B sur WeryAI. L'outil détecte automatiquement le gris et applique la fonction « Coloriser » pour ajouter des couleurs réalistes instantanément."
                    },
                    {
                        "question": "Peut-il réparer une photo déchirée ou rayée ?",
                        "answer": "Oui. Notre IA est entraînée à reconnaître rayures, déchirures et plis. Elle comble ces zones avec des pixels qui correspondent à la texture environnante."
                    },
                    {
                        "question": "La photo restaurée risque-t-elle de paraître fausse ?",
                        "answer": "Notre objectif est le réalisme. L'amélioration du visage ajoute des détails tout en gardant l'identité reconnaissable. Pour la colorisation, l'IA choisit des tons naturels adaptés à l'époque."
                    },
                    {
                        "question": "Et si la photo est très petite ?",
                        "answer": "Aucun souci. Le processus inclut aussi l'Upscaling, qui augmente la résolution des petites photos pour l'affichage numérique ou l'impression."
                    },
                    {
                        "question": "Ma confidentialité est-elle protégée ?",
                        "answer": "Oui. Nous savons que les vieilles photos sont personnelles. Vos images sont traitées de façon sécurisée et ne sont pas stockées de manière permanente sur nos serveurs."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Comment coloriser une photo noir et blanc ?",
                    "answer": "Téléchargez votre image N&B sur WeryAI : la fonction « Coloriser » ajoute des couleurs réalistes instantanément."
                },
                {
                    "question": "Peut-il réparer une photo déchirée ou rayée ?",
                    "answer": "Oui. L'IA détecte les dommages et les reconstruit en respectant la texture environnante."
                },
                {
                    "question": "La photo restaurée risque-t-elle de paraître fausse ?",
                    "answer": "Nous privilégions le réalisme : identité reconnaissable et couleurs naturelles adaptées."
                }
            ],
            "feature_title1": "Suppression des Rayures & Déchirures",
            "feature_desc1": "Effacez les marques du temps : détection et remplissage automatiques des plis, rayures, déchirures et poussières. L'IA reconstruit les détails manquants pour un rendu comme neuf.",
            "feature_title2": "Colorisation Intelligente",
            "feature_desc2": "N&B vers Couleur : pas un simple filtre sépia. Notre modèle comprend le contexte (ciel, peau, tissu) pour ajouter des couleurs vives et réalistes.",
            "feature_title3": "Amélioration du Visage",
            "feature_desc3": "Défloutez les visages : les vieilles photos souffrent souvent de flou de mouvement ou de mise au point. WeryAI affine les traits (yeux, nez, bouche) pour révéler la ressemblance.",
            "howto": {
                "name": "Comment coloriser et restaurer de vieilles photos",
                "step1": {
                    "name": "Télécharger la photo",
                    "text": "Téléchargez une photo ancienne, endommagée ou en noir et blanc sur WeryAI."
                },
                "step2": {
                    "name": "Traitement IA",
                    "text": "L'IA détectera automatiquement les dommages et les informations de couleur. Elle réparera les rayures et appliquera la couleur simultanément."
                },
                "step3": {
                    "name": "Télécharger",
                    "text": "Prévisualisez l'image restaurée et téléchargez la version haute qualité."
                }
            }
        }
    },
    "de": {
        "photoRestoration": {
            "title": "KI-Fotorestaurierung - Alte Fotos Reparieren | WeryAI",
            "description": "Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.",
            "keywords": "alte fotos restaurieren, foto kolorieren, zerkratzte fotos reparieren, KI fotorestauration, schwarz weiß zu farbe, bild reparatur KI, foto aufbereitung",
            "og_title": "KI-Fotorestaurierung - Alte Fotos Reparieren | WeryAI",
            "og_description": "Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.",
            "twitter_title": "KI-Fotorestaurierung - Alte Fotos Reparieren | WeryAI",
            "twitter_description": "Beleben Sie alte Familienerinnerungen mit WeryAIs kostenloser KI-Fotorestauration. Kolorieren Sie Schwarz-Weiß-Fotos automatisch und entfernen Sie Kratzer, Risse und Unschärfe – Gesichter werden sofort wiederhergestellt.",
            "page": {
                "title1": "Kostenlose KI-Restauration & Kolorierung alter Fotos",
                "title2": "Bringen Sie Ihre Geschichte zurück. Ob verblasstes Schwarz-Weiß-Hochzeitsfoto oder zerkratztes Kinderporträt: Unsere KI analysiert und repariert beschädigte Bereiche, schärft Gesichter und fügt in Sekunden realistische Farben hinzu.",
                "faq": [
                    {
                        "question": "Wie koloriert man ein Schwarz-Weiß-Foto?",
                        "answer": "Laden Sie Ihr S/W-Bild bei WeryAI hoch. Das Tool erkennt automatisch Graustufen und wendet die Funktion „Kolorieren“ an, um sofort realistische Farben hinzuzufügen."
                    },
                    {
                        "question": "Kann es zerrissene oder zerkratzte Fotos reparieren?",
                        "answer": "Ja. Unsere KI erkennt Kratzer, Risse und Knicke und füllt die beschädigten Stellen mit Pixeln, die zur umliegenden Textur passen."
                    },
                    {
                        "question": "Sieht das restaurierte Foto künstlich aus?",
                        "answer": "Unser Ziel ist Realismus. Die Gesichtsverbesserung fügt Details hinzu, ohne die Identität zu verfälschen. Bei der Kolorierung wählt die KI natürliche Farbtöne passend zur Epoche."
                    },
                    {
                        "question": "Was, wenn das Foto sehr klein ist?",
                        "answer": "Kein Problem. Der Prozess enthält auch Upscaling, wodurch die Auflösung kleiner Fotos für die digitale Ansicht oder den Druck erhöht wird."
                    },
                    {
                        "question": "Ist meine Privatsphäre geschützt?",
                        "answer": "Ja. Wir wissen, dass alte Fotos persönlich sind. Ihre Bilder werden sicher verarbeitet und nicht dauerhaft auf unseren Servern gespeichert."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Wie koloriert man ein Schwarz-Weiß-Foto?",
                    "answer": "Einfach S/W-Foto hochladen – die Funktion „Kolorieren“ fügt sofort realistische Farben hinzu."
                },
                {
                    "question": "Kann es zerrissene oder zerkratzte Fotos reparieren?",
                    "answer": "Ja. Die KI erkennt Schäden und rekonstruiert sie passend zur umgebenden Textur."
                },
                {
                    "question": "Sieht das restaurierte Foto künstlich aus?",
                    "answer": "Wir priorisieren Realismus und eine erkennbare Identität – mit natürlichen, passenden Farben."
                }
            ],
            "feature_title1": "Kratzer- & Riss-Entfernung",
            "feature_desc1": "Spuren der Zeit löschen: Knicke, Kratzer, Risse und Staubflecken automatisch erkennen und füllen. Die KI rekonstruiert fehlende Gesichtsdetails, damit das Foto wieder wie neu wirkt.",
            "feature_title2": "Intelligente Kolorierung",
            "feature_desc2": "S/W zu Farbe: Nicht nur ein Sepia-Filter. Das Deep-Learning-Modell versteht Kontext (Himmel, Haut, Stoff) und fügt lebendige, natürliche Farben hinzu.",
            "feature_title3": "Gesichtsverbesserung",
            "feature_desc3": "Gesichter entblurren: Alte Fotos leiden oft unter Bewegungsunschärfe oder schlechtem Fokus. WeryAI schärft Gesichtszüge (Augen, Nase, Mund) und bringt das echte Aussehen zurück.",
            "howto": {
                "name": "Wie man alte Fotos koloriert und restauriert",
                "step1": {
                    "name": "Foto hochladen",
                    "text": "Laden Sie ein altes, beschädigtes oder schwarz-weißes Foto bei WeryAI hoch."
                },
                "step2": {
                    "name": "KI-Verarbeitung",
                    "text": "Die KI erkennt automatisch Schäden und Farbinformationen. Sie repariert Kratzer und wendet gleichzeitig Farbe an."
                },
                "step3": {
                    "name": "Herunterladen",
                    "text": "Sehen Sie sich das restaurierte Bild in der Vorschau an und laden Sie die hochwertige Version herunter."
                }
            }
        }
    },
    "ru": {
        "photoRestoration": {
            "title": "ИИ Восстановление Старых Фото | WeryAI",
            "description": "Оживите семейные воспоминания с бесплатным AI-восстановлением фото от WeryAI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.",
            "keywords": "восстановление старых фото, раскрасить ч/б фото, убрать царапины фото, AI ремонт фото, восстановить старые фотографии, черно-белое в цвет, восстановление изображений AI",
            "og_title": "ИИ Восстановление Старых Фото | WeryAI",
            "og_description": "Оживите семейные воспоминания с бесплатным AI-восстановлением фото от WeryAI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.",
            "twitter_title": "ИИ Восстановление Старых Фото | WeryAI",
            "twitter_description": "Оживите семейные воспоминания с бесплатным AI-восстановлением фото от WeryAI. Автоматически раскрашивайте черно-белые снимки, удаляйте царапины, разрывы и размытость — лица восстанавливаются мгновенно.",
            "page": {
                "title1": "Бесплатное восстановление и раскраска старых фото с AI",
                "title2": "Верните историю к жизни. Будь то выцветшее черно-белое свадебное фото или поцарапанный детский портрет — AI анализирует и восстанавливает повреждения, повышает резкость лиц и добавляет реалистичные цвета за секунды.",
                "faq": [
                    {
                        "question": "Как раскрасить черно-белое фото?",
                        "answer": "Просто загрузите Ч/Б изображение в WeryAI. Инструмент сам определит градации серого и применит функцию «Colorize», чтобы добавить реалистичные цвета мгновенно."
                    },
                    {
                        "question": "Можно ли исправить порванные или поцарапанные фото?",
                        "answer": "Да. AI обучен распознавать царапины, разрывы и заломы и заполняет поврежденные области пикселями, которые совпадают с окружающей текстурой."
                    },
                    {
                        "question": "Фото после восстановления будет выглядеть “ненастоящим”?",
                        "answer": "Мы стремимся к реалистичности. Улучшение лица добавляет детали, но сохраняет узнаваемость. При раскраске AI выбирает естественные тона, подходящие для эпохи."
                    },
                    {
                        "question": "Что если фото очень маленькое?",
                        "answer": "Не проблема. Процесс включает Upscaling — повышение разрешения маленьких фото для цифрового просмотра или печати."
                    },
                    {
                        "question": "Защищена ли моя приватность?",
                        "answer": "Да. Мы понимаем, что старые фото — личные. Изображения обрабатываются безопасно и не хранятся на серверах постоянно."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Как раскрасить черно-белое фото?",
                    "answer": "Загрузите Ч/Б фото — функция «Colorize» добавит реалистичные цвета мгновенно."
                },
                {
                    "question": "Можно ли исправить порванные или поцарапанные фото?",
                    "answer": "Да. AI распознаёт повреждения и восстанавливает их с учетом текстуры вокруг."
                },
                {
                    "question": "Фото после восстановления будет выглядеть “ненастоящим”?",
                    "answer": "Мы приоритизируем реализм и узнаваемость — с естественной цветокоррекцией."
                }
            ],
            "feature_title1": "Удаление царапин и разрывов",
            "feature_desc1": "Стереть следы времени: автоматически обнаруживаем и заполняем заломы, царапины, разрывы и пыль. AI восстанавливает утраченные детали лица, чтобы фото выглядело как новое.",
            "feature_title2": "Интеллектуальная раскраска",
            "feature_desc2": "Ч/Б → цвет: не просто сепия. Модель понимает контекст (небо, кожа, ткань) и добавляет живые, естественные цвета старым снимкам.",
            "feature_title3": "Улучшение лица",
            "feature_desc3": "Убрать размытость: старые фото часто страдают от смаза и плохого фокуса. WeryAI повышает резкость черт (глаза, нос, рот), возвращая настоящее сходство.",
            "howto": {
                "name": "Как раскрасить и восстановить старые фото",
                "step1": {
                    "name": "Загрузить фото",
                    "text": "Загрузите старое, поврежденное или черно-белое фото в WeryAI."
                },
                "step2": {
                    "name": "Обработка ИИ",
                    "text": "ИИ автоматически обнаружит повреждения и информацию о цвете. Он восстановит царапины и одновременно применит цвет."
                },
                "step3": {
                    "name": "Скачать",
                    "text": "Просмотрите восстановленное изображение и скачайте версию в высоком качестве."
                }
            }
        }
    },
    "pt": {
        "photoRestoration": {
            "title": "Restaurar Fotos Antigas com IA | WeryAI",
            "description": "Reviva memórias de família com a Restauração de Foto com IA Grátis da WeryAI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.",
            "keywords": "restauração de foto antiga, colorizar foto, reparar foto riscada, reparo de foto IA, restaurar fotos antigas, preto e branco para cor, restauração de imagem IA",
            "og_title": "Restaurar Fotos Antigas com IA | WeryAI",
            "og_description": "Reviva memórias de família com a Restauração de Foto com IA Grátis da WeryAI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.",
            "twitter_title": "Restaurar Fotos Antigas com IA | WeryAI",
            "twitter_description": "Reviva memórias de família com a Restauração de Foto com IA Grátis da WeryAI. Colorize automaticamente fotos em preto e branco, remova riscos, rasgos e desfoque para restaurar rostos em segundos.",
            "page": {
                "title1": "Restaurador e Colorizador de Fotos Antigas com IA (Grátis)",
                "title2": "Traga sua história de volta à vida. Seja uma foto de casamento P&B desbotada ou um retrato de infância riscado, nossa IA analisa e restaura áreas danificadas, melhora rostos e adiciona cores realistas em segundos.",
                "faq": [
                    {
                        "question": "Como colorir uma foto em preto e branco?",
                        "answer": "Basta enviar sua imagem P&B para a WeryAI. A ferramenta detecta o modo em escala de cinza e aplica o recurso “Colorizar” para adicionar cores realistas instantaneamente."
                    },
                    {
                        "question": "Consegue consertar fotos rasgadas ou riscadas?",
                        "answer": "Sim. Nossa IA reconhece riscos, rasgos e dobras e preenche as áreas danificadas com pixels que combinam com a textura ao redor."
                    },
                    {
                        "question": "A foto restaurada vai parecer falsa?",
                        "answer": "Nosso foco é realismo. A melhoria facial adiciona detalhes mantendo a identidade reconhecível. Na colorização, a IA escolhe tons naturais adequados à época."
                    },
                    {
                        "question": "E se a foto for muito pequena?",
                        "answer": "Sem problema. O processo inclui Upscaling, aumentando a resolução de fotos pequenas para visualização digital ou impressão."
                    },
                    {
                        "question": "Minha privacidade está protegida?",
                        "answer": "Sim. Sabemos que fotos antigas são pessoais. Suas imagens são processadas com segurança e não são armazenadas permanentemente em nossos servidores."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Como colorir uma foto em preto e branco?",
                    "answer": "Envie a imagem P&B e o recurso “Colorizar” adiciona cores realistas instantaneamente."
                },
                {
                    "question": "Consegue consertar fotos rasgadas ou riscadas?",
                    "answer": "Sim. A IA detecta danos e reconstrói de acordo com a textura ao redor."
                },
                {
                    "question": "A foto restaurada vai parecer falsa?",
                    "answer": "Priorizamos realismo e identidade reconhecível, com cores naturais."
                }
            ],
            "feature_title1": "Remoção de Riscos & Rasgos",
            "feature_desc1": "Apague as marcas do tempo: detecte e preencha dobras, riscos, rasgos e manchas de poeira automaticamente. A IA reconstrói detalhes faciais perdidos para a foto parecer nova.",
            "feature_title2": "Colorização Inteligente",
            "feature_desc2": "P&B para Cor: não é só um filtro sépia. O modelo entende contexto (céu, pele, tecido) para adicionar cores vibrantes e realistas a fotos antigas.",
            "feature_title3": "Aprimoramento de Rosto",
            "feature_desc3": "Desborrar rostos: fotos antigas sofrem com desfoque e falta de foco. A WeryAI realça traços (olhos, nariz, boca) para revelar a semelhança real.",
            "howto": {
                "name": "Como colorir e restaurar fotos antigas",
                "step1": {
                    "name": "Enviar foto",
                    "text": "Envie uma foto antiga, danificada ou em preto e branco para o WeryAI."
                },
                "step2": {
                    "name": "Processamento de IA",
                    "text": "A IA detectará automaticamente danos e informações de cores. Ela reparará arranhões e aplicará cor simultaneamente."
                },
                "step3": {
                    "name": "Baixar",
                    "text": "Visualize a imagem restaurada e baixe a versão de alta qualidade."
                }
            }
        }
    },
    "it": {
        "photoRestoration": {
            "title": "Restauro Foto con IA - Riparare Vecchie Foto | WeryAI",
            "description": "Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di WeryAI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.",
            "keywords": "restauro foto antiche, colorare foto, riparare foto graffiate, riparazione foto AI, restaurare vecchie foto, bianco e nero a colori, restauro immagini AI",
            "og_title": "Restauro Foto con IA - Riparare Vecchie Foto | WeryAI",
            "og_description": "Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di WeryAI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.",
            "twitter_title": "Restauro Foto con IA - Riparare Vecchie Foto | WeryAI",
            "twitter_description": "Ravviva i ricordi di famiglia con il Restauro Foto AI gratuito di WeryAI. Colora automaticamente le foto in bianco e nero, rimuove graffi, strappi e sfocature per ripristinare i volti in pochi secondi.",
            "page": {
                "title1": "Restauro e Colorazione di Vecchie Foto con AI (Gratis)",
                "title2": "Riporta in vita la tua storia. Che sia una foto di matrimonio in bianco e nero sbiadita o un ritratto d'infanzia graffiato, la nostra AI analizza e ripristina le aree danneggiate, rende i volti più nitidi e aggiunge colori realistici in pochi secondi.",
                "faq": [
                    {
                        "question": "Come posso colorare una foto in bianco e nero?",
                        "answer": "Carica la tua immagine B/N su WeryAI. Lo strumento rileva automaticamente la scala di grigi e applica la funzione “Colorizza” per aggiungere colori realistici subito."
                    },
                    {
                        "question": "Può riparare foto strappate o graffiate?",
                        "answer": "Sì. La nostra AI riconosce graffi, strappi e pieghe e riempie le aree danneggiate con pixel che corrispondono alla texture circostante."
                    },
                    {
                        "question": "La foto restaurata sembrerà finta?",
                        "answer": "Il nostro obiettivo è il realismo. Il miglioramento del volto aggiunge dettagli mantenendo l'identità riconoscibile. Nella colorazione, l'AI sceglie tonalità naturali adatte all'epoca."
                    },
                    {
                        "question": "E se la foto è molto piccola?",
                        "answer": "Nessun problema. Il processo include anche l'Upscaling, che aumenta la risoluzione delle foto piccole per la visualizzazione digitale o la stampa."
                    },
                    {
                        "question": "La mia privacy è protetta?",
                        "answer": "Sì. Sappiamo che le vecchie foto sono personali. Le tue immagini vengono elaborate in modo sicuro e non vengono conservate in modo permanente sui nostri server."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Come posso colorare una foto in bianco e nero?",
                    "answer": "Carica la foto B/N: la funzione “Colorizza” aggiunge colori realistici all'istante."
                },
                {
                    "question": "Può riparare foto strappate o graffiate?",
                    "answer": "Sì. L'AI rileva i danni e li ricostruisce rispettando la texture intorno."
                },
                {
                    "question": "La foto restaurata sembrerà finta?",
                    "answer": "Puntiamo al realismo, mantenendo l'identità e applicando colori naturali."
                }
            ],
            "feature_title1": "Rimozione Graffi & Strappi",
            "feature_desc1": "Cancella i segni del tempo: rileva e riempie automaticamente pieghe, graffi, strappi e macchie di polvere. L'AI ricostruisce dettagli facciali mancanti per far sembrare la foto come nuova.",
            "feature_title2": "Colorazione Intelligente",
            "feature_desc2": "Da B/N a Colore: non è un filtro seppia. Il nostro modello capisce il contesto (cielo, pelle, tessuti) e aggiunge colori vividi e realistici alle foto in bianco e nero.",
            "feature_title3": "Miglioramento del Volto",
            "feature_desc3": "Rendi nitidi i volti: le vecchie foto spesso soffrono di mosso o scarsa messa a fuoco. WeryAI migliora i tratti (occhi, naso, bocca) per rivelare la vera somiglianza.",
            "howto": {
                "name": "Come colorare e restaurare vecchie foto",
                "step1": {
                    "name": "Carica foto",
                    "text": "Carica una foto vecchia, danneggiata o in bianco e nero su WeryAI."
                },
                "step2": {
                    "name": "Elaborazione IA",
                    "text": "L'IA rileverà automaticamente i danni e le informazioni sul colore. Riparerà i graffi e applicherà il colore contemporaneamente."
                },
                "step3": {
                    "name": "Scarica",
                    "text": "Visualizza l'anteprima dell'immagine restaurata e scarica la versione di alta qualità."
                }
            }
        }
    },
    "ar": {
        "photoRestoration": {
            "title": "استعادة الصور القديمة بالذكاء الاصطناعي | WeryAI",
            "description": "أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من WeryAI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.",
            "keywords": "استعادة الصور القديمة, تلوين صور أبيض وأسود, إصلاح صور مخدوشة, إصلاح الصور بالذكاء الاصطناعي, استرجاع الصور القديمة, من الأبيض والأسود إلى الألوان, ترميم الصور بالذكاء الاصطناعي",
            "og_title": "استعادة الصور القديمة بالذكاء الاصطناعي | WeryAI",
            "og_description": "أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من WeryAI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.",
            "twitter_title": "استعادة الصور القديمة بالذكاء الاصطناعي | WeryAI",
            "twitter_description": "أعد إحياء ذكريات العائلة مع استعادة الصور المجانية من WeryAI. لوّن صور الأبيض والأسود تلقائيًا وأزل الخدوش والتمزقات والضبابية لاستعادة الوجوه فورًا.",
            "page": {
                "title1": "استعادة وتلوين الصور القديمة بالذكاء الاصطناعي (مجانًا)",
                "title2": "أعد تاريخك إلى الحياة. سواء كانت صورة زفاف باهتة بالأبيض والأسود أو بورتريه طفولة مليئًا بالخدوش، يقوم الذكاء الاصطناعي بتحليل المناطق التالفة واستعادتها، وتحسين وضوح الوجوه، وإضافة ألوان واقعية خلال ثوانٍ.",
                "faq": [
                    {
                        "question": "كيف ألوّن صورة بالأبيض والأسود؟",
                        "answer": "ارفع صورتك بالأبيض والأسود إلى WeryAI. سيكتشف النظام تلقائيًا أنها رمادية ويطبّق ميزة “التلوين” لإضافة ألوان واقعية فورًا."
                    },
                    {
                        "question": "هل يمكنه إصلاح الصور الممزقة أو المخدوشة؟",
                        "answer": "نعم. تم تدريب الذكاء الاصطناعي على التعرف على الخدوش والتمزقات والثنيات، ثم يملأ المناطق التالفة ببكسلات تطابق الملمس المحيط."
                    },
                    {
                        "question": "هل ستبدو الصورة المستعادة مزيفة؟",
                        "answer": "هدفنا هو الواقعية. تحسين الوجه يضيف تفاصيل مع الحفاظ على هوية الشخص واضحة. وفي التلوين، يختار الذكاء الاصطناعي درجات طبيعية مناسبة للعصر."
                    },
                    {
                        "question": "ماذا لو كانت الصورة صغيرة جدًا؟",
                        "answer": "لا مشكلة. تتضمن العملية أيضًا Upscaling لرفع دقة الصور الصغيرة للعرض الرقمي أو الطباعة."
                    },
                    {
                        "question": "هل خصوصيتي محمية؟",
                        "answer": "نعم. نعلم أن الصور القديمة شخصية. تتم معالجة صورك بأمان ولا يتم تخزينها بشكل دائم على خوادمنا."
                    }
                ]
            },
            "faq": [
                {
                    "question": "كيف ألوّن صورة بالأبيض والأسود؟",
                    "answer": "ارفع صورتك وسيقوم خيار “التلوين” بإضافة ألوان واقعية فورًا."
                },
                {
                    "question": "هل يمكنه إصلاح الصور الممزقة أو المخدوشة؟",
                    "answer": "نعم. يكتشف الذكاء الاصطناعي التلف ويعيد بناءه وفقًا للملمس المحيط."
                },
                {
                    "question": "هل ستبدو الصورة المستعادة مزيفة؟",
                    "answer": "نركز على الواقعية والحفاظ على الهوية مع ألوان طبيعية."
                }
            ],
            "feature_title1": "إزالة الخدوش والتمزقات",
            "feature_desc1": "امسح آثار الزمن: اكتشف تلقائيًا الثنيات والخدوش والتمزقات وبقع الغبار واملأها. يعيد الذكاء الاصطناعي بناء تفاصيل الوجه المفقودة لتبدو الصورة كالجديدة.",
            "feature_title2": "تلوين ذكي",
            "feature_desc2": "من الأبيض والأسود إلى الألوان: ليس مجرد فلتر سيبيا. يفهم نموذج التعلم العميق السياق (السماء، البشرة، القماش) لإضافة ألوان نابضة وواقعية للصور القديمة.",
            "feature_title3": "تحسين الوجه",
            "feature_desc3": "إزالة ضبابية الوجوه: غالبًا ما تعاني الصور القديمة من اهتزاز أو ضعف تركيز. يقوم WeryAI بتحسين ملامح الوجه (العينين، الأنف، الفم) لإظهار الشبه الحقيقي.",
            "howto": {
                "name": "كيفية تلوين واستعادة الصور القديمة",
                "step1": {
                    "name": "تحميل الصورة",
                    "text": "قم بتحميل صورة قديمة أو تالفة أو بالأبيض والأسود إلى WeryAI."
                },
                "step2": {
                    "name": "معالجة الذكاء الاصطناعي",
                    "text": "سيكتشف الذكاء الاصطناعي التلف ومعلومات الألوان تلقائيًا. سيقوم بإصلاح الخدوش وتطبيق اللون في وقت واحد."
                },
                "step3": {
                    "name": "تنزيل",
                    "text": "قم بمعاينة الصورة المستعادة وقم بتنزيل الإصدار عالي الجودة."
                }
            }
        }
    },
    "tw": {
        "photoRestoration": {
            "title": "免費 AI 老照片修復 - 修復舊照片 | WeryAI",
            "description": "把泛黃、模糊或受損的舊照片重新修復清晰。WeryAI 可去除劃痕、補足細節、提升人像清晰度，還能為黑白照片自然上色。",
            "keywords": "舊照片修復, 照片上色, 修復劃痕照片, AI 照片修理, 修復舊圖片, 黑白轉彩色, 圖像修復 AI",
            "og_title": "免費 AI 老照片修復 - 修復舊照片 | WeryAI",
            "og_description": "把泛黃、模糊或受損的舊照片重新修復清晰。WeryAI 可去除劃痕、補足細節、提升人像清晰度，還能為黑白照片自然上色。",
            "twitter_title": "免費 AI 老照片修復 - 修復舊照片 | WeryAI",
            "twitter_description": "把泛黃、模糊或受損的舊照片重新修復清晰。WeryAI 可去除劃痕、補足細節、提升人像清晰度，還能為黑白照片自然上色。",
            "page": {
                "title1": "免費 AI 老照片修復與上色工具",
                "title2": "讓您的歷史重獲新生。無論是褪色的黑白婚紗照還是劃痕累累的童年肖像，我們的 AI 都能在幾秒鐘內分析並修復受損區域，銳化人臉，智慧添加逼真的顏色。",
                "faq": [
                    {
                        "question": "如何為黑白照片上色？",
                        "answer": "只需將您的黑白圖像上傳到 WeryAI。工具會自動偵測它是灰階圖像，並套用「上色」功能，立即添加逼真的顏色。"
                    },
                    {
                        "question": "可以修復撕裂或劃痕的照片嗎？",
                        "answer": "可以。我們的 AI 經過訓練，能夠識別劃痕、撕裂和摺痕。它會用與周圍紋理匹配的像素填補這些受損區域。"
                    },
                    {
                        "question": "修復後的照片會看起來很假嗎？",
                        "answer": "我們的目標是真實感。雖然人臉增強會添加細節，但我們努力保持人物身份的可識別性。對於上色，AI 會選擇適合該時代的自然色調。"
                    },
                    {
                        "question": "如果照片非常小怎麼辦？",
                        "answer": "沒問題。修復過程還包括放大功能，可以提高小尺寸照片的解析度，用於數位檢視或列印。"
                    },
                    {
                        "question": "我的隱私是否受到保護？",
                        "answer": "是的。我們理解舊照片是私人的。您的圖像會被安全處理，不會永久儲存在我們的伺服器上。"
                    },
                    {
                        "question": "我可以免費使用 WeryAI 照片修復功能嗎？",
                        "answer": "可以。新用戶註冊即可獲得免費點數，無需綁定信用卡。您還可以透過每日簽到、完成任務和邀請好友獲得更多免費點數，因此可以持續使用照片修復工具而無需預付費用。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "如何為黑白照片上色？",
                    "answer": "只需將黑白圖像上傳到 WeryAI，工具會自動偵測並套用「上色」功能，立即添加逼真的顏色。"
                },
                {
                    "question": "可以修復撕裂或劃痕的照片嗎？",
                    "answer": "可以。AI 能識別劃痕和撕裂，並用與周圍紋理匹配的像素自然修復。"
                },
                {
                    "question": "修復後的照片會看起來很假嗎？",
                    "answer": "我們以真實感為優先，保持人物身份可識別，同時進行自然的修復和上色。"
                },
                {
                    "question": "我可以免費使用 WeryAI 照片修復功能嗎？",
                    "answer": "可以。新用戶註冊即可獲得免費點數，無需綁定信用卡。透過每日簽到、完成任務和邀請好友可獲得更多免費點數。"
                }
            ],
            "feature_title1": "劃痕與撕裂去除",
            "feature_desc1": "擦除時間的痕跡：自動偵測並填補摺痕、劃痕、撕裂和灰塵斑點。我們的 AI 重建缺失的面部細節，讓照片看起來煥然一新。",
            "feature_title2": "智慧上色",
            "feature_desc2": "黑白轉彩色：不僅僅是棕褐色濾鏡。我們的深度學習模型理解上下文（天空、皮膚、織物），為黑白照片添加歷史上準確且生動的顏色。",
            "feature_title3": "人臉增強",
            "feature_desc3": "去模糊人臉：舊照片經常遭受手震或低焦點問題。WeryAI 銳化面部特徵（眼睛、鼻子、嘴巴），揭示您祖先的真實面貌。",
            "howto": {
                "name": "如何為老照片上色和修復",
                "step1": {
                    "name": "上傳照片",
                    "text": "將舊的、損壞的或黑白照片上傳到 WeryAI。"
                },
                "step2": {
                    "name": "AI 處理",
                    "text": "AI 將自動偵測損壞和顏色資訊。它會同時修復劃痕和上色。"
                },
                "step3": {
                    "name": "下載",
                    "text": "預覽修復後的圖片並下載高品質版本。"
                }
            }
        }
    },
    "pl": {
        "photoRestoration": {
            "title": "Darmowa Restauracja Zdjęć AI - Napraw Stare Zdjęcia | WeryAI",
            "description": "Przywróć stare zdjęcia rodzinne dzięki AI — pokoloruj czarno-białe obrazy, napraw zadrapania i wyostrz rozmyte detale. Darmowe kredyty na start, bez karty kredytowej.",
            "keywords": "restauracja starych zdjęć, kolorowanie zdjęć, naprawa zarysowanych zdjęć, AI naprawa zdjęć, przywracanie starych fotografii, czarno-białe na kolorowe, WeryAI",
            "og_title": "Darmowa Restauracja Zdjęć AI - Napraw Stare Zdjęcia | WeryAI",
            "og_description": "Przywróć stare zdjęcia rodzinne dzięki AI — pokoloruj czarno-białe obrazy, napraw zadrapania i wyostrz rozmyte detale. Darmowe kredyty na start, bez karty kredytowej.",
            "twitter_title": "Darmowa Restauracja Zdjęć AI - Napraw Stare Zdjęcia | WeryAI",
            "twitter_description": "Przywróć stare zdjęcia rodzinne dzięki AI — pokoloruj czarno-białe obrazy, napraw zadrapania i wyostrz rozmyte detale. Darmowe kredyty na start, bez karty kredytowej.",
            "page": {
                "title1": "Darmowa Restauracja i Kolorowanie Starych Zdjęć AI",
                "title2": "Przywróć historię do życia. Niezależnie od tego, czy to wyblakłe czarno-białe zdjęcie ślubne, czy porysowany portret z dzieciństwa — nasza AI analizuje i naprawia uszkodzenia, wyostrza twarze i dodaje realistyczne kolory w kilka sekund.",
                "faq": [
                    {
                        "question": "Jak pokolorować czarno-białe zdjęcie?",
                        "answer": "Wystarczy przesłać obraz czarno-biały do WeryAI. Narzędzie automatycznie wykryje odcienie szarości i zastosuje funkcję \"Kolorowanie\", aby natychmiast dodać realistyczne kolory."
                    },
                    {
                        "question": "Czy może naprawić podarte lub porysowane zdjęcia?",
                        "answer": "Tak. Nasza AI rozpoznaje zarysowania, rozdarcia i zagięcia. Wypełnia uszkodzone obszary pikselami pasującymi do otaczającej tekstury."
                    },
                    {
                        "question": "Czy odrestaurowane zdjęcie będzie wyglądać sztucznie?",
                        "answer": "Naszym celem jest realizm. Ulepszenie twarzy dodaje detale, ale staramy się zachować rozpoznawalną tożsamość osoby. Przy kolorowaniu AI wybiera naturalne tony odpowiednie dla epoki."
                    },
                    {
                        "question": "A jeśli zdjęcie jest bardzo małe?",
                        "answer": "Nie ma problemu. Proces restauracji obejmuje również powiększanie, które zwiększa rozdzielczość małych zdjęć do oglądania cyfrowego lub druku."
                    },
                    {
                        "question": "Czy moja prywatność jest chroniona?",
                        "answer": "Tak. Rozumiemy, że stare zdjęcia są osobiste. Twoje obrazy są przetwarzane bezpiecznie i nie są trwale przechowywane na naszych serwerach."
                    },
                    {
                        "question": "Czy mogę korzystać z WeryAI Photo Restoration za darmo?",
                        "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji bez podawania karty kredytowej. Możesz też zdobyć więcej darmowych kredytów poprzez codzienne logowanie, wykonywanie zadań i zapraszanie znajomych, co pozwala korzystać z narzędzia bez opłat wstępnych."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Jak pokolorować czarno-białe zdjęcie?",
                    "answer": "Prześlij obraz czarno-biały do WeryAI, a funkcja \"Kolorowanie\" natychmiast doda realistyczne kolory."
                },
                {
                    "question": "Czy może naprawić podarte lub porysowane zdjęcia?",
                    "answer": "Tak. AI wykrywa uszkodzenia i odtwarza je naturalnie, dopasowując do otaczającej tekstury."
                },
                {
                    "question": "Czy odrestaurowane zdjęcie będzie wyglądać sztucznie?",
                    "answer": "Stawiamy na realizm: zachowujemy rozpoznawalną tożsamość i stosujemy naturalne, odpowiednie kolory."
                },
                {
                    "question": "Czy mogę korzystać z WeryAI Photo Restoration za darmo?",
                    "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji. Więcej kredytów można zdobyć przez codzienne logowanie, zadania i zapraszanie znajomych."
                }
            ],
            "feature_title1": "Usuwanie Zarysowań i Rozdarć",
            "feature_desc1": "Wymaż ślady czasu: Automatycznie wykryj i wypełnij zagięcia, zarysowania, rozdarcia i plamy kurzu. Nasza AI odtwarza brakujące detale twarzy, by zdjęcie wyglądało jak nowe.",
            "feature_title2": "Inteligentne Kolorowanie",
            "feature_desc2": "Z czarno-białego na kolorowe: To nie zwykły filtr sepii. Nasz model deep learning rozumie kontekst (niebo, skóra, tkanina) i dodaje żywe, realistyczne kolory do starych zdjęć.",
            "feature_title3": "Ulepszenie Twarzy",
            "feature_desc3": "Wyostrz twarze: Stare zdjęcia często cierpią na rozmycie ruchu lub niski fokus. WeryAI wyostrza rysy twarzy (oczy, nos, usta), by ukazać prawdziwe podobieństwo Twoich przodków.",
            "howto": {
                "name": "Jak pokolorować i przywrócić stare zdjęcia",
                "step1": {
                    "name": "Prześlij zdjęcie",
                    "text": "Prześlij stare, zniszczone lub czarno-białe zdjęcie do WeryAI."
                },
                "step2": {
                    "name": "Przetwarzanie AI",
                    "text": "AI automatycznie wykryje uszkodzenia i informacje o kolorze. Naprawi zadrapania i jednocześnie nałoży kolor."
                },
                "step3": {
                    "name": "Pobierz",
                    "text": "Wyświetl podgląd przywróconego obrazu i pobierz wersję w wysokiej jakości."
                }
            }
        }
    },
    "th": {
        "photoRestoration": {
            "title": "ซ่อมแซมรูปภาพเก่า AI ฟรี - ฟื้นฟูภาพถ่ายเก่า | WeryAI",
            "description": "ฟื้นฟูภาพถ่ายครอบครัวเก่าด้วย AI — ลงสีภาพขาวดำ ซ่อมรอยขีดข่วน และทำให้รายละเอียดเบลอชัดขึ้น เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "keywords": "ซ่อมแซมภาพเก่า, ลงสีภาพขาวดำ, ซ่อมภาพขีดข่วน, AI ซ่อมภาพ, กู้คืนภาพเก่า, ขาวดำเป็นสี, WeryAI",
            "og_title": "ซ่อมแซมรูปภาพเก่า AI ฟรี - ฟื้นฟูภาพถ่ายเก่า | WeryAI",
            "og_description": "ฟื้นฟูภาพถ่ายครอบครัวเก่าด้วย AI — ลงสีภาพขาวดำ ซ่อมรอยขีดข่วน และทำให้รายละเอียดเบลอชัดขึ้น เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "twitter_title": "ซ่อมแซมรูปภาพเก่า AI ฟรี - ฟื้นฟูภาพถ่ายเก่า | WeryAI",
            "twitter_description": "ฟื้นฟูภาพถ่ายครอบครัวเก่าด้วย AI — ลงสีภาพขาวดำ ซ่อมรอยขีดข่วน และทำให้รายละเอียดเบลอชัดขึ้น เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "page": {
                "title1": "เครื่องมือฟื้นฟูและลงสีภาพเก่า AI ฟรี",
                "title2": "ทำให้ประวัติศาสตร์ของคุณกลับมามีชีวิต ไม่ว่าจะเป็นภาพแต่งงานขาวดำที่ซีดจาง หรือภาพเด็กที่เต็มไปด้วยรอยขีดข่วน AI จะวิเคราะห์และฟื้นฟูส่วนที่เสียหาย ทำให้ใบหน้าคมชัด และเพิ่มสีสันที่เหมือนจริงในไม่กี่วินาที",
                "faq": [
                    {
                        "question": "ฉันจะลงสีภาพขาวดำได้อย่างไร?",
                        "answer": "เพียงอัปโหลดภาพขาวดำไปที่ WeryAI เครื่องมือจะตรวจจับโดยอัตโนมัติว่าเป็นภาพเฉดเทาและใช้ฟีเจอร์ \"ลงสี\" เพื่อเพิ่มสีที่เหมือนจริงทันที"
                    },
                    {
                        "question": "สามารถซ่อมภาพที่ฉีกขาดหรือมีรอยขีดข่วนได้ไหม?",
                        "answer": "ได้ AI ของเราถูกฝึกให้จดจำรอยขีดข่วน รอยฉีกขาด และรอยพับ มันจะเติมส่วนที่เสียหายด้วยพิกเซลที่ตรงกับพื้นผิวรอบข้าง"
                    },
                    {
                        "question": "ภาพที่ฟื้นฟูแล้วจะดูปลอมไหม?",
                        "answer": "เป้าหมายของเราคือความสมจริง การปรับปรุงใบหน้าจะเพิ่มรายละเอียดแต่ยังคงรักษาเอกลักษณ์ให้จดจำได้ สำหรับการลงสี AI จะเลือกโทนสีธรรมชาติที่เหมาะกับยุคสมัย"
                    },
                    {
                        "question": "ถ้าภาพเล็กมากล่ะ?",
                        "answer": "ไม่มีปัญหา กระบวนการฟื้นฟูรวมถึงการขยายภาพด้วย ซึ่งจะเพิ่มความละเอียดของภาพขนาดเล็กสำหรับดูดิจิทัลหรือพิมพ์"
                    },
                    {
                        "question": "ความเป็นส่วนตัวของฉันได้รับการปกป้องไหม?",
                        "answer": "ได้ เราเข้าใจว่าภาพเก่าเป็นเรื่องส่วนตัว ภาพของคุณจะถูกประมวลผลอย่างปลอดภัยและจะไม่ถูกจัดเก็บถาวรบนเซิร์ฟเวอร์ของเรา"
                    },
                    {
                        "question": "ฉันสามารถใช้ WeryAI Photo Restoration ฟรีได้ไหม?",
                        "answer": "ได้ ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต คุณยังสามารถรับเครดิตฟรีเพิ่มเติมผ่านการเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน จึงใช้งานต่อเนื่องได้โดยไม่ต้องจ่ายล่วงหน้า"
                    }
                ]
            },
            "faq": [
                {
                    "question": "ฉันจะลงสีภาพขาวดำได้อย่างไร?",
                    "answer": "อัปโหลดภาพขาวดำไปที่ WeryAI แล้วฟีเจอร์ \"ลงสี\" จะเพิ่มสีที่เหมือนจริงทันที"
                },
                {
                    "question": "สามารถซ่อมภาพที่ฉีกขาดหรือมีรอยขีดข่วนได้ไหม?",
                    "answer": "ได้ AI ตรวจจับความเสียหายและฟื้นฟูตามพื้นผิวรอบข้าง"
                },
                {
                    "question": "ภาพที่ฟื้นฟูแล้วจะดูปลอมไหม?",
                    "answer": "เราให้ความสำคัญกับความสมจริงและรักษาเอกลักษณ์ของบุคคล พร้อมใช้สีธรรมชาติ"
                },
                {
                    "question": "ฉันสามารถใช้ WeryAI Photo Restoration ฟรีได้ไหม?",
                    "answer": "ได้ ผู้ใช้ใหม่ได้เครดิตฟรีเมื่อสมัคร รับเพิ่มได้จากเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน"
                }
            ],
            "feature_title1": "ลบรอยขีดข่วนและรอยฉีกขาด",
            "feature_desc1": "ลบร่องรอยแห่งกาลเวลา: ตรวจจับและเติมรอยพับ รอยขีดข่วน รอยฉีก และจุดฝุ่นอัตโนมัติ AI ของเราสร้างรายละเอียดใบหน้าที่หายไปขึ้นมาใหม่เพื่อให้ภาพดูเหมือนใหม่",
            "feature_title2": "ลงสีอัจฉริยะ",
            "feature_desc2": "ขาวดำเป็นสี: ไม่ใช่แค่ฟิลเตอร์ซีเปีย โมเดล Deep Learning ของเราเข้าใจบริบท (ท้องฟ้า ผิวหนัง ผ้า) เพื่อเพิ่มสีสันที่มีชีวิตชีวาและเหมือนจริงให้กับภาพขาวดำ",
            "feature_title3": "ปรับปรุงใบหน้า",
            "feature_desc3": "ทำให้ใบหน้าคมชัด: ภาพเก่ามักมีปัญหาเบลอจากการเคลื่อนไหวหรือโฟกัสต่ำ WeryAI ทำให้ลักษณะใบหน้า (ตา จมูก ปาก) คมชัดขึ้นเพื่อเผยให้เห็นความเหมือนที่แท้จริง",
            "howto": {
                "name": "วิธีลงสีและฟื้นฟูภาพเก่า",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปภาพเก่า เสียหาย หรือขาวดำไปที่ WeryAI"
                },
                "step2": {
                    "name": "การประมวลผล AI",
                    "text": "AI จะตรวจจับความเสียหายและข้อมูลสีโดยอัตโนมัติ จะซ่อมแซมรอยขีดข่วนและลงสีพร้อมกัน"
                },
                "step3": {
                    "name": "ดาวน์โหลด",
                    "text": "ดูตัวอย่างภาพที่ฟื้นฟูแล้วและดาวน์โหลดเวอร์ชันคุณภาพสูง"
                }
            }
        }
    },
    "da": {
        "photoRestoration": {
            "title": "Gratis AI Fotorestaurering - Reparer Gamle Fotos | WeryAI",
            "description": "Gendan gamle familiebilleder med AI — farvelæg sort-hvide fotos, reparer ridser og skærp slørede detaljer. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "keywords": "fotorestaurering, farvelæg fotos, reparer ridsede fotos, AI fotoreparation, gendan gamle billeder, sort-hvid til farve, WeryAI",
            "og_title": "Gratis AI Fotorestaurering - Reparer Gamle Fotos | WeryAI",
            "og_description": "Gendan gamle familiebilleder med AI — farvelæg sort-hvide fotos, reparer ridser og skærp slørede detaljer. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "twitter_title": "Gratis AI Fotorestaurering - Reparer Gamle Fotos | WeryAI",
            "twitter_description": "Gendan gamle familiebilleder med AI — farvelæg sort-hvide fotos, reparer ridser og skærp slørede detaljer. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "page": {
                "title1": "Gratis AI Restaurering og Farvelægning af Gamle Fotos",
                "title2": "Bring din historie til live igen. Uanset om det er et falmet sort-hvidt bryllupsfoto eller et ridset barndomsportræt, analyserer og reparerer vores AI beskadigede områder, skærper ansigter og tilføjer realistiske farver på sekunder.",
                "faq": [
                    {
                        "question": "Hvordan farvelægger jeg et sort-hvidt foto?",
                        "answer": "Upload bare dit S/H-billede til WeryAI. Værktøjet registrerer automatisk gråtoner og anvender funktionen \"Farvelæg\" for straks at tilføje realistiske farver."
                    },
                    {
                        "question": "Kan det reparere revnede eller ridsede fotos?",
                        "answer": "Ja. Vores AI er trænet til at genkende ridser, revner og folder. Den udfylder beskadigede områder med pixels, der matcher den omgivende tekstur."
                    },
                    {
                        "question": "Vil det restaurerede foto se falsk ud?",
                        "answer": "Vores mål er realisme. Ansigtsforbedringe tilføjer detaljer, men vi bestræber os på at bevare personens identitet genkendelig. Ved farvelægning vælger AI naturlige toner, der passer til æraen."
                    },
                    {
                        "question": "Hvad hvis fotoet er meget lille?",
                        "answer": "Intet problem. Restaureringsprocessen inkluderer også opskalering, som øger opløsningen af små fotos til digital visning eller print."
                    },
                    {
                        "question": "Er mit privatliv beskyttet?",
                        "answer": "Ja. Vi forstår, at gamle fotos er personlige. Dine billeder behandles sikkert og gemmes ikke permanent på vores servere."
                    },
                    {
                        "question": "Kan jeg bruge WeryAI Photo Restoration gratis?",
                        "answer": "Ja. Nye brugere får gratis credits ved tilmelding uden kreditkort. Du kan også optjene flere gratis credits via dagligt check-in, fuldførte opgaver og ved at invitere venner, så du kan fortsætte med at bruge værktøjet uden forudbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan farvelægger jeg et sort-hvidt foto?",
                    "answer": "Upload dit S/H-billede til WeryAI, og funktionen \"Farvelæg\" tilføjer straks realistiske farver."
                },
                {
                    "question": "Kan det reparere revnede eller ridsede fotos?",
                    "answer": "Ja. AI registrerer skader og genopbygger dem naturligt ud fra den omgivende tekstur."
                },
                {
                    "question": "Vil det restaurerede foto se falsk ud?",
                    "answer": "Vi prioriterer realisme og genkendelig identitet med naturlige, passende farver."
                },
                {
                    "question": "Kan jeg bruge WeryAI Photo Restoration gratis?",
                    "answer": "Ja. Nye brugere får gratis credits ved tilmelding. Tjen flere via dagligt check-in, opgaver og invitationer."
                }
            ],
            "feature_title1": "Fjernelse af Ridser og Revner",
            "feature_desc1": "Slet tidens mærker: Registrer og udfyld automatisk folder, ridser, revner og støvpletter. Vores AI genskaber manglende ansigtsdetaljer, så fotoet ser ud som nyt.",
            "feature_title2": "Intelligent Farvelægning",
            "feature_desc2": "S/H til Farve: Ikke bare et sepia-filter. Vores deep learning-model forstår kontekst (himmel, hud, stof) og tilføjer levende, realistiske farver til sort-hvide fotos.",
            "feature_title3": "Ansigts­forbedring",
            "feature_desc3": "Gør ansigter skarpe: Gamle fotos lider ofte af bevægelsessløring eller dårlig fokus. WeryAI skærper ansigtstræk (øjne, næse, mund) for at afsløre den sande lighed.",
            "howto": {
                "name": "Sådan farvelægger og gendanner du gamle fotos",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload et gammelt, beskadiget eller sort-hvidt foto til WeryAI."
                },
                "step2": {
                    "name": "AI-behandling",
                    "text": "AI'en registrerer automatisk skader og farveoplysninger. Den reparerer ridser og anvender farve samtidigt."
                },
                "step3": {
                    "name": "Download",
                    "text": "Forhåndsvis det gendannede billede og download versionen i høj kvalitet."
                }
            }
        }
    },
    "no": {
        "photoRestoration": {
            "title": "Gratis AI Fotorestaurering - Reparer Gamle Bilder | WeryAI",
            "description": "Gjenopprett gamle familiebilder med AI — fargelegg svart-hvite bilder, reparer riper og skjerp uskarpe detaljer. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "keywords": "fotorestaurering, fargelegge bilder, reparere ripete bilder, AI bildereparasjon, gjenopprette gamle bilder, svart-hvitt til farge, WeryAI",
            "og_title": "Gratis AI Fotorestaurering - Reparer Gamle Bilder | WeryAI",
            "og_description": "Gjenopprett gamle familiebilder med AI — fargelegg svart-hvite bilder, reparer riper og skjerp uskarpe detaljer. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "twitter_title": "Gratis AI Fotorestaurering - Reparer Gamle Bilder | WeryAI",
            "twitter_description": "Gjenopprett gamle familiebilder med AI — fargelegg svart-hvite bilder, reparer riper og skjerp uskarpe detaljer. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "page": {
                "title1": "Gratis AI Restaurering og Fargelagging av Gamle Bilder",
                "title2": "Bring historien din tilbake til livet. Enten det er et falmet svart-hvitt bryllupsbilde eller et ripet barndomsportrett, analyserer og reparerer vår AI skadede områder, skjerper ansikter og legger til realistiske farger på sekunder.",
                "faq": [
                    {
                        "question": "Hvordan fargelegger jeg et svart-hvitt bilde?",
                        "answer": "Last bare opp S/H-bildet ditt til WeryAI. Verktøyet oppdager automatisk gråtoner og bruker funksjonen \"Fargelegg\" for å legge til realistiske farger umiddelbart."
                    },
                    {
                        "question": "Kan det reparere revnede eller ripete bilder?",
                        "answer": "Ja. Vår AI gjenkjenner riper, revner og bretter. Den fyller skadede områder med piksler som matcher den omkringliggende teksturen."
                    },
                    {
                        "question": "Vil det restaurerte bildet se falskt ut?",
                        "answer": "Målet vårt er realisme. Ansiktsforbedring legger til detaljer, men vi bevarer gjenkjennelig identitet. Ved fargelagging velger AI naturlige toner som passer til epoken."
                    },
                    {
                        "question": "Hva om bildet er veldig lite?",
                        "answer": "Ikke noe problem. Restaureringsprosessen inkluderer også oppskalering, som øker oppløsningen på små bilder for digital visning eller utskrift."
                    },
                    {
                        "question": "Er personvernet mitt beskyttet?",
                        "answer": "Ja. Vi forstår at gamle bilder er personlige. Bildene dine behandles sikkert og lagres ikke permanent på serverne våre."
                    },
                    {
                        "question": "Kan jeg bruke WeryAI Photo Restoration gratis?",
                        "answer": "Ja. Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også tjene flere gratis kreditter gjennom daglig innsjekking, fullføre oppgaver og invitere venner, slik at du kan fortsette å bruke verktøyet uten forhåndsbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvordan fargelegger jeg et svart-hvitt bilde?",
                    "answer": "Last opp S/H-bildet ditt til WeryAI, og funksjonen \"Fargelegg\" legger til realistiske farger umiddelbart."
                },
                {
                    "question": "Kan det reparere revnede eller ripete bilder?",
                    "answer": "Ja. AI oppdager skader og gjenoppbygger dem naturlig etter teksturen rundt."
                },
                {
                    "question": "Vil det restaurerte bildet se falskt ut?",
                    "answer": "Vi prioriterer realisme og gjenkjennelig identitet med naturlige, passende farger."
                },
                {
                    "question": "Kan jeg bruke WeryAI Photo Restoration gratis?",
                    "answer": "Ja. Nye brukere får gratis kreditter ved registrering. Tjen flere via daglig innsjekking, oppgaver og invitasjoner."
                }
            ],
            "feature_title1": "Fjerning av Riper og Revner",
            "feature_desc1": "Slett tidens merker: Oppdag og fyll automatisk bretter, riper, revner og støvflekker. Vår AI gjenoppbygger manglende ansiktsdetaljer slik at bildet ser ut som nytt.",
            "feature_title2": "Intelligent Fargelagging",
            "feature_desc2": "S/H til Farge: Ikke bare et sepia-filter. Vår deep learning-modell forstår kontekst (himmel, hud, stoff) og legger til livlige, realistiske farger på svart-hvite bilder.",
            "feature_title3": "Ansiktsforbedring",
            "feature_desc3": "Gjør ansikter skarpe: Gamle bilder lider ofte av bevegelsesuskarphet eller dårlig fokus. WeryAI skjerper ansiktstrekk (øyne, nese, munn) for å avsløre den virkelige likheten.",
            "howto": {
                "name": "Hvordan fargelegge og gjenopprette gamle bilder",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp et gammelt, skadet eller svart-hvitt bilde til WeryAI."
                },
                "step2": {
                    "name": "AI-behandling",
                    "text": "AI-en oppdager automatisk skader og fargeinformasjon. Den reparerer riper og legger til farge samtidig."
                },
                "step3": {
                    "name": "Last ned",
                    "text": "Forhåndsvis det gjenopprettede bildet og last ned høykvalitetsversjonen."
                }
            }
        }
    },
    "nl": {
        "photoRestoration": {
            "title": "Gratis AI Fotorestauratie - Herstel Oude Foto's | WeryAI",
            "description": "Herstel oude familiefoto's met AI — kleur zwart-wit foto's in, repareer krassen en verscherp onscherpe details. Gratis credits bij aanmelding, geen creditcard nodig.",
            "keywords": "fotorestauratie, foto's inkleuren, gekraste foto's repareren, AI fotoherstel, oude foto's herstellen, zwart-wit naar kleur, WeryAI",
            "og_title": "Gratis AI Fotorestauratie - Herstel Oude Foto's | WeryAI",
            "og_description": "Herstel oude familiefoto's met AI — kleur zwart-wit foto's in, repareer krassen en verscherp onscherpe details. Gratis credits bij aanmelding, geen creditcard nodig.",
            "twitter_title": "Gratis AI Fotorestauratie - Herstel Oude Foto's | WeryAI",
            "twitter_description": "Herstel oude familiefoto's met AI — kleur zwart-wit foto's in, repareer krassen en verscherp onscherpe details. Gratis credits bij aanmelding, geen creditcard nodig.",
            "page": {
                "title1": "Gratis AI Restauratie en Inkleuring van Oude Foto's",
                "title2": "Breng je geschiedenis weer tot leven. Of het nu een vervaagde zwart-wit trouwfoto is of een bekrast kinderfoto — onze AI analyseert en herstelt beschadigde gebieden, verscherpt gezichten en voegt in enkele seconden realistische kleuren toe.",
                "faq": [
                    {
                        "question": "Hoe kleur ik een zwart-wit foto in?",
                        "answer": "Upload gewoon je Z/W-afbeelding naar WeryAI. Het hulpmiddel detecteert automatisch grijstinten en past de functie \"Inkleuren\" toe om direct realistische kleuren toe te voegen."
                    },
                    {
                        "question": "Kan het gescheurde of gekraste foto's repareren?",
                        "answer": "Ja. Onze AI herkent krassen, scheuren en vouwen. Het vult beschadigde gebieden met pixels die overeenkomen met de omringende textuur."
                    },
                    {
                        "question": "Ziet de gerestaureerde foto er nep uit?",
                        "answer": "Ons doel is realisme. Gezichtsverbetering voegt details toe, maar we behouden de herkenbare identiteit. Bij inkleuring kiest de AI natuurlijke tinten die passen bij het tijdperk."
                    },
                    {
                        "question": "Wat als de foto heel klein is?",
                        "answer": "Geen probleem. Het restauratieproces omvat ook opschaling, waardoor de resolutie van kleine foto's wordt verhoogd voor digitale weergave of afdrukken."
                    },
                    {
                        "question": "Is mijn privacy beschermd?",
                        "answer": "Ja. We begrijpen dat oude foto's persoonlijk zijn. Je afbeeldingen worden veilig verwerkt en worden niet permanent opgeslagen op onze servers."
                    },
                    {
                        "question": "Kan ik WeryAI Photo Restoration gratis gebruiken?",
                        "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij aanmelding zonder creditcard. Je kunt ook meer gratis credits verdienen via dagelijkse check-in, taken voltooien en vrienden uitnodigen, zodat je de tool kunt blijven gebruiken zonder voorafbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hoe kleur ik een zwart-wit foto in?",
                    "answer": "Upload je Z/W-afbeelding naar WeryAI en de functie \"Inkleuren\" voegt direct realistische kleuren toe."
                },
                {
                    "question": "Kan het gescheurde of gekraste foto's repareren?",
                    "answer": "Ja. De AI detecteert schade en herstelt deze op natuurlijke wijze op basis van de omringende textuur."
                },
                {
                    "question": "Ziet de gerestaureerde foto er nep uit?",
                    "answer": "We geven prioriteit aan realisme en herkenbare identiteit, met natuurlijke en passende kleuren."
                },
                {
                    "question": "Kan ik WeryAI Photo Restoration gratis gebruiken?",
                    "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij aanmelding. Verdien meer via dagelijkse check-in, taken en uitnodigingen."
                }
            ],
            "feature_title1": "Verwijdering van Krassen en Scheuren",
            "feature_desc1": "Wis de sporen van de tijd: Detecteer en vul automatisch vouwen, krassen, scheuren en stofvlekken. Onze AI herstelt ontbrekende gezichtsdetails zodat de foto er als nieuw uitziet.",
            "feature_title2": "Intelligente Inkleuring",
            "feature_desc2": "Z/W naar Kleur: Niet zomaar een sepia-filter. Ons deep learning-model begrijpt context (lucht, huid, stof) en voegt levendige, realistische kleuren toe aan zwart-wit foto's.",
            "feature_title3": "Gezichtsverbetering",
            "feature_desc3": "Verscherp gezichten: Oude foto's hebben vaak last van bewegingsonscherpte of slechte focus. WeryAI verscherpt gelaatstrekken (ogen, neus, mond) om de ware gelijkenis te onthullen.",
            "howto": {
                "name": "Hoe oude foto's in te kleuren en te herstellen",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload een oude, beschadigde of zwart-wit foto naar WeryAI."
                },
                "step2": {
                    "name": "AI-verwerking",
                    "text": "De AI detecteert automatisch schade en kleurinformatie. Het repareert krassen en past tegelijkertijd kleur toe."
                },
                "step3": {
                    "name": "Downloaden",
                    "text": "Bekijk een voorbeeld van de herstelde afbeelding en download de versie van hoge kwaliteit."
                }
            }
        }
    },
    "id": {
        "photoRestoration": {
            "title": "Restorasi Foto Lama AI Gratis - Perbaiki Foto Lama | WeryAI",
            "description": "Pulihkan foto keluarga lama dengan AI — warnai foto hitam putih, perbaiki goresan, dan pertajam detail buram. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "keywords": "restorasi foto lama, mewarnai foto, perbaiki foto tergores, AI perbaikan foto, pulihkan foto lama, hitam putih ke warna, WeryAI",
            "og_title": "Restorasi Foto Lama AI Gratis - Perbaiki Foto Lama | WeryAI",
            "og_description": "Pulihkan foto keluarga lama dengan AI — warnai foto hitam putih, perbaiki goresan, dan pertajam detail buram. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "twitter_title": "Restorasi Foto Lama AI Gratis - Perbaiki Foto Lama | WeryAI",
            "twitter_description": "Pulihkan foto keluarga lama dengan AI — warnai foto hitam putih, perbaiki goresan, dan pertajam detail buram. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "page": {
                "title1": "Restorasi dan Pewarnaan Foto Lama AI Gratis",
                "title2": "Hidupkan kembali sejarah Anda. Baik foto pernikahan hitam putih yang pudar maupun potret masa kecil yang tergores, AI kami menganalisis dan memperbaiki area yang rusak, mempertajam wajah, dan menambahkan warna realistis dalam hitungan detik.",
                "faq": [
                    {
                        "question": "Bagaimana cara mewarnai foto hitam putih?",
                        "answer": "Cukup unggah gambar hitam putih Anda ke WeryAI. Alat ini secara otomatis mendeteksi gambar grayscale dan menerapkan fitur \"Warnai\" untuk menambahkan warna realistis secara instan."
                    },
                    {
                        "question": "Bisakah memperbaiki foto yang sobek atau tergores?",
                        "answer": "Bisa. AI kami dilatih untuk mengenali goresan, sobekan, dan lipatan. Ia mengisi area yang rusak dengan piksel yang cocok dengan tekstur sekitarnya."
                    },
                    {
                        "question": "Apakah foto yang dipulihkan akan terlihat palsu?",
                        "answer": "Tujuan kami adalah realisme. Peningkatan wajah menambah detail sambil menjaga identitas tetap dapat dikenali. Untuk pewarnaan, AI memilih nada alami yang sesuai dengan era tersebut."
                    },
                    {
                        "question": "Bagaimana jika fotonya sangat kecil?",
                        "answer": "Tidak masalah. Proses restorasi juga mencakup pembesaran, yang meningkatkan resolusi foto kecil untuk tampilan digital atau cetak."
                    },
                    {
                        "question": "Apakah privasi saya dilindungi?",
                        "answer": "Ya. Kami memahami bahwa foto lama bersifat pribadi. Gambar Anda diproses dengan aman dan tidak disimpan secara permanen di server kami."
                    },
                    {
                        "question": "Bisakah saya menggunakan WeryAI Photo Restoration secara gratis?",
                        "answer": "Bisa. Pengguna baru mendapat kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga bisa terus menggunakan alat ini tanpa pembayaran di muka."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bagaimana cara mewarnai foto hitam putih?",
                    "answer": "Unggah gambar hitam putih ke WeryAI dan fitur \"Warnai\" akan menambahkan warna realistis secara instan."
                },
                {
                    "question": "Bisakah memperbaiki foto yang sobek atau tergores?",
                    "answer": "Bisa. AI mendeteksi kerusakan dan membangunnya kembali secara alami sesuai tekstur sekitarnya."
                },
                {
                    "question": "Apakah foto yang dipulihkan akan terlihat palsu?",
                    "answer": "Kami memprioritaskan realisme dan identitas yang dapat dikenali, dengan warna alami yang sesuai."
                },
                {
                    "question": "Bisakah saya menggunakan WeryAI Photo Restoration secara gratis?",
                    "answer": "Bisa. Pengguna baru mendapat kredit gratis saat mendaftar. Dapatkan lebih banyak melalui check-in harian, tugas, dan undangan."
                }
            ],
            "feature_title1": "Penghapusan Goresan & Sobekan",
            "feature_desc1": "Hapus bekas waktu: Deteksi dan isi lipatan, goresan, sobekan, dan bintik debu secara otomatis. AI kami merekonstruksi detail wajah yang hilang agar foto terlihat seperti baru.",
            "feature_title2": "Pewarnaan Cerdas",
            "feature_desc2": "Hitam Putih ke Warna: Bukan sekadar filter sepia. Model deep learning kami memahami konteks (langit, kulit, kain) untuk menambahkan warna yang hidup dan realistis pada foto hitam putih.",
            "feature_title3": "Peningkatan Wajah",
            "feature_desc3": "Pertajam wajah: Foto lama sering menderita blur gerakan atau fokus rendah. WeryAI mempertajam fitur wajah (mata, hidung, mulut) untuk mengungkapkan kemiripan yang sebenarnya.",
            "howto": {
                "name": "Cara Mewarnai dan Memulihkan Foto Lama",
                "step1": {
                    "name": "Unggah Foto",
                    "text": "Unggah foto lama, rusak, atau hitam putih ke WeryAI."
                },
                "step2": {
                    "name": "Pemrosesan AI",
                    "text": "AI akan secara otomatis mendeteksi kerusakan dan informasi warna. Ia akan memperbaiki goresan dan menerapkan warna secara bersamaan."
                },
                "step3": {
                    "name": "Unduh",
                    "text": "Pratinjau gambar yang dipulihkan dan unduh versi berkualitas tinggi."
                }
            }
        }
    },
    "tr": {
        "photoRestoration": {
            "title": "Ücretsiz AI Fotoğraf Restorasyonu - Eski Fotoğrafları Onarın | WeryAI",
            "description": "Eski aile fotoğraflarını AI ile restore edin — siyah beyaz fotoğrafları renklendirin, çizikleri onarın ve bulanık detayları keskinleştirin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "keywords": "eski fotoğraf restorasyonu, fotoğraf renklendirme, çizik fotoğraf onarma, AI fotoğraf onarımı, eski fotoğrafları geri yükleme, siyah beyazdan renkli, WeryAI",
            "og_title": "Ücretsiz AI Fotoğraf Restorasyonu - Eski Fotoğrafları Onarın | WeryAI",
            "og_description": "Eski aile fotoğraflarını AI ile restore edin — siyah beyaz fotoğrafları renklendirin, çizikleri onarın ve bulanık detayları keskinleştirin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "twitter_title": "Ücretsiz AI Fotoğraf Restorasyonu - Eski Fotoğrafları Onarın | WeryAI",
            "twitter_description": "Eski aile fotoğraflarını AI ile restore edin — siyah beyaz fotoğrafları renklendirin, çizikleri onarın ve bulanık detayları keskinleştirin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "page": {
                "title1": "Ücretsiz AI Eski Fotoğraf Restorasyonu ve Renklendirme",
                "title2": "Tarihinizi yeniden canlandırın. İster solmuş siyah beyaz bir düğün fotoğrafı ister çizik dolu bir çocukluk portresi olsun, AI'mız hasarlı alanları analiz edip onarır, yüzleri keskinleştirir ve saniyeler içinde gerçekçi renkler ekler.",
                "faq": [
                    {
                        "question": "Siyah beyaz bir fotoğrafı nasıl renklendiririm?",
                        "answer": "S/B görüntünüzü WeryAI'ye yükleyin. Araç, gri tonlamaları otomatik olarak algılar ve anında gerçekçi renkler eklemek için \"Renklendir\" özelliğini uygular."
                    },
                    {
                        "question": "Yırtık veya çizik fotoğrafları onarabilir mi?",
                        "answer": "Evet. AI'mız çizikleri, yırtıkları ve kırışıklıkları tanımak üzere eğitilmiştir. Hasarlı alanları çevredeki dokuyla eşleşen piksellerle doldurur."
                    },
                    {
                        "question": "Restore edilen fotoğraf sahte mi görünecek?",
                        "answer": "Amacımız gerçekçiliktir. Yüz iyileştirme detay ekler ama kişinin kimliğini tanınabilir tutarız. Renklendirmede AI, döneme uygun doğal tonlar seçer."
                    },
                    {
                        "question": "Fotoğraf çok küçükse ne olur?",
                        "answer": "Sorun değil. Restorasyon süreci ayrıca küçük fotoğrafların çözünürlüğünü dijital görüntüleme veya baskı için artıran Upscaling içerir."
                    },
                    {
                        "question": "Gizliliğim korunuyor mu?",
                        "answer": "Evet. Eski fotoğrafların kişisel olduğunu biliyoruz. Görüntüleriniz güvenli bir şekilde işlenir ve sunucularımızda kalıcı olarak saklanmaz."
                    },
                    {
                        "question": "WeryAI Photo Restoration'ı ücretsiz kullanabilir miyim?",
                        "answer": "Evet. Yeni kullanıcılar kayıt olduklarında kredi kartı gerekmeden ücretsiz kredi alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davet etme yoluyla daha fazla ücretsiz kredi kazanabilirsiniz, böylece ön ödeme yapmadan aracı kullanmaya devam edebilirsiniz."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Siyah beyaz bir fotoğrafı nasıl renklendiririm?",
                    "answer": "S/B görüntünüzü WeryAI'ye yükleyin ve \"Renklendir\" özelliği anında gerçekçi renkler ekler."
                },
                {
                    "question": "Yırtık veya çizik fotoğrafları onarabilir mi?",
                    "answer": "Evet. AI hasarı algılar ve çevredeki dokuya göre doğal şekilde yeniden oluşturur."
                },
                {
                    "question": "Restore edilen fotoğraf sahte mi görünecek?",
                    "answer": "Gerçekçiliğe ve tanınabilir kimliğe öncelik veriyoruz — doğal ve uygun renklerle."
                },
                {
                    "question": "WeryAI Photo Restoration'ı ücretsiz kullanabilir miyim?",
                    "answer": "Evet. Yeni kullanıcılar kayıtta ücretsiz kredi alır. Günlük giriş, görevler ve davetlerle daha fazla kazanın."
                }
            ],
            "feature_title1": "Çizik ve Yırtık Giderme",
            "feature_desc1": "Zamanın izlerini silin: Kırışıklıkları, çizikleri, yırtıkları ve toz lekelerini otomatik olarak algılayın ve doldurun. AI'mız eksik yüz detaylarını yeniden oluşturarak fotoğrafın yeni gibi görünmesini sağlar.",
            "feature_title2": "Akıllı Renklendirme",
            "feature_desc2": "S/B'den Renkli'ye: Sadece bir sepia filtresi değil. Derin öğrenme modelimiz bağlamı (gökyüzü, cilt, kumaş) anlar ve siyah beyaz fotoğraflara canlı, gerçekçi renkler ekler.",
            "feature_title3": "Yüz İyileştirme",
            "feature_desc3": "Yüzleri keskinleştirin: Eski fotoğraflar genellikle hareket bulanıklığı veya düşük odaktan muzdariptir. WeryAI yüz özelliklerini (gözler, burun, ağız) keskinleştirerek gerçek benzerliği ortaya çıkarır.",
            "howto": {
                "name": "Eski Fotoğraflar Nasıl Renklendirilir ve Restore Edilir",
                "step1": {
                    "name": "Fotoğraf Yükle",
                    "text": "Eski, hasarlı veya siyah beyaz bir fotoğrafı WeryAI'ye yükleyin."
                },
                "step2": {
                    "name": "AI İşleme",
                    "text": "AI hasarı ve renk bilgilerini otomatik olarak algılayacaktır. Çizikleri onaracak ve aynı anda renk uygulayacaktır."
                },
                "step3": {
                    "name": "İndir",
                    "text": "Restore edilen görüntüyü önizleyin ve yüksek kaliteli sürümü indirin."
                }
            }
        }
    }
}
